<div class="map-wrapper">
  <div class="map-actions">
    <button
      mat-fab
      (click)="centerOnUser()"
      aria-label="Auf meine Position zentrieren"
      [disabled]="!userMarker"
      class="map-button"
    >
      <mat-icon>my_location</mat-icon>
    </button>
    <button mat-fab (click)="toggleFilterSidenav()" aria-label="Filter öffnen" class="map-button">
      <mat-icon>filter_alt</mat-icon>
    </button>
  </div>

  <div
    class="map-container"
    leaflet
    [leafletOptions]="options"
    [leafletLayers]="layers"
    (leafletMapReady)="onMapReady($event)"
  >
  </div>
</div>
